import { gluer } from 'femo';
// 精确匹配到的路由
export const currentExactMatchRoad = gluer(null);
